import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'


interface SelfAssessmentComponentProps {
  levels: number[]
  canEditSelf: boolean
handleScoreChange: (field: keyof SelfAssessmentScoreState, value: number | string) => void
  currentScore: SelfAssessmentScoreState
  levelDescriptions: Record<number, string>
}

interface SelfAssessmentScoreState {
    selfLevel: number | null
    selfNotes: string
}

const SelfAssessmentComponent = ({ levels, canEditSelf, handleScoreChange, currentScore, levelDescriptions }: SelfAssessmentComponentProps) => {
  return (
    <div className="card-body">
    <div className="d-flex align-items-center justify-content-between mb-3">
      <h2 className="h6 fw-semibold mb-0">Self Assessment</h2>
    </div>

    <div className="mb-4">
      <label className="form-label fw-semibold text-muted small mb-2">
        Self Score (1-5)
      </label>
      <div className="d-flex gap-2">
        {levels.map((level) => (
          <button
            key={level}
            type="button"
            disabled={!canEditSelf}
            onClick={() => handleScoreChange('selfLevel', level)}
            className={`gw-score-button gw-score-button--self ${
              currentScore.selfLevel === level ? 'is-active' : ''
            }`}
          >
            <span className="h5 mb-0">{level}</span>
          </button>
        ))}
      </div>
    </div>

    {currentScore.selfLevel && (
      <div className="mb-4 gw-assessment-level-card gw-assessment-level-card--self">
        <div className="d-flex gap-2">
          <FontAwesomeIcon
            icon={faCircleInfo}
            className="gw-assessment-level-icon"
          />
          <div>
            <div className="fw-semibold small mb-1">
              Level {currentScore.selfLevel} Description
            </div>
            <p className="small mb-0">
              {levelDescriptions[currentScore.selfLevel]}
            </p>
          </div>
        </div>
      </div>
    )}

    <div>
      <label className="form-label fw-semibold text-muted small mb-2">
        Your Notes
      </label>
      <textarea
        disabled={!canEditSelf}
        value={currentScore.selfNotes}
        onChange={(event) => handleScoreChange('selfNotes', event.target.value)}
        placeholder="Add reflections, examples, or areas for growth..."
        rows={6}
        className={`form-control gw-assessment-textarea gw-assessment-textarea--self ${
          !canEditSelf ? 'bg-light' : ''
        }`}
      />
    </div>
  </div>
  )
}

export default SelfAssessmentComponent